














































































































































import Vue from "vue";

// Import Models
import { RecipeSchema } from "../../models/recipe.model";
import { Ingredient } from "../../models/formulationStep.model";

// Import Internal Components
import RecipeSteps from "./RecipeSteps.vue";
import ShareModalContent from "./ShareModalContent.vue";

// Import External Components
import ButtonGroup from "@miele/component-library-vue/src/components/elements/button/ButtonGroup.vue";
import Button from "@miele/component-library-vue/src/components/elements/button/Button.vue";
import TeaserImage from "@miele/component-library-vue/src/components/modules/teaser/TeaserImage.vue";
import Modal from "@miele/component-library-vue/src/components/elements/objects/Modal.vue";
import Block from "@miele/component-library-vue/src/components/content/layouts/Block.vue";
import ImageTile from "@miele/component-library-vue/src/components/modules/image-tile/ImageTile.vue";

export default Vue.extend({
  name: "LayoutRecipeDetail",
  data() {
    return {
      modalId: "shareRecipeModal",
      printIcon:
        "M70.481,25.316H65.823V2.025C65.823.627,64.386,0,62.988,0H18.025c-1.4,0-2.835.627-2.835,2.025V25.316H10.532A10.833,10.833,0,0,0,0,35.747V54.481A10.744,10.744,0,0,0,10.532,64.81H15.19V76.962A3.283,3.283,0,0,0,18.025,80H62.988a3.283,3.283,0,0,0,2.835-3.038V64.81h4.658c5.528,0,9.519-4.8,9.519-10.329V35.747C80,30.219,76.009,25.316,70.481,25.316ZM20.253,5.063H60.759V25.316H20.253ZM60.759,74.937H20.253V49.62H60.759ZM74.937,54.481c0,2.736-1.72,5.266-4.456,5.266H65.823V46.988a2.726,2.726,0,0,0-2.835-2.431H18.025a2.726,2.726,0,0,0-2.835,2.431V59.747H10.532a5.691,5.691,0,0,1-5.468-5.266V35.747a5.783,5.783,0,0,1,5.468-5.367H70.481c2.736,0,4.456,2.631,4.456,5.367Z",
      recommendIcon:
        "M63.818,50.909a14.5,14.5,0,0,0-10.312,4.3l-23.382-11.3a14.358,14.358,0,0,0,.6-3.916,14.358,14.358,0,0,0-.6-3.921L53.493,24.774a14.533,14.533,0,1,0-4.221-10.228,14.358,14.358,0,0,0,.6,3.921L26.507,29.772a14.545,14.545,0,1,0,0,20.457L49.882,61.521a14.354,14.354,0,0,0-.609,3.934A14.545,14.545,0,1,0,63.818,50.909Zm0-43.636a7.273,7.273,0,1,1-7.273,7.273A7.282,7.282,0,0,1,63.818,7.273Zm-47.636,40A7.273,7.273,0,1,1,23.455,40,7.282,7.282,0,0,1,16.182,47.273ZM63.818,72.727a7.282,7.282,0,0,1-7.273-7.273,7.185,7.185,0,0,1,1-3.617c.009-.015.023-.025.032-.041s.008-.032.016-.047a7.26,7.26,0,1,1,6.223,10.978Z",
    };
  },
  props: {
    recipe: {
      type: Object as () => RecipeSchema,
      required: true,
    },
  },
  components: {
    RecipeSteps,
    ButtonGroup,
    Button,
    TeaserImage,
    Modal,
    ShareModalContent,
    Block,
    ImageTile
  },
  computed: {
    recipeTitle(): string {
      return this.recipe.title;
    },
    recipeUrl(): string {
      var currentUrl = window.location.href;
      return currentUrl;
    },
    portionSize(): number {
      return this.recipe.servings.quantity;
    },
    ingredients(): Array<Record<string, any>> {
      return this.recipe.ingredients.sort(
        (a: any, b: any) => b?.quantity - a?.quantity
      );
    },
    utensils(): Array<string> {
      return this.recipe.utensils;
    },
    steps(): Array<Record<string, any>> {
      return this.recipe.formulationSteps;
    },
    videos(): Array<Record<string, any>> {
      return this.recipe.videos;
    },
    appliance(): any {
      return this.$store.getters.getAllAppliances;
    },
    serving(): string {
      const portionSize = this.recipe.servings.quantity;
      const upToSize = this.recipe.servings?.quantityUpTo;

      if (this.recipe.servings.unit?.other !== null && portionSize > 1) {
        if (upToSize !== null) {
          return `${portionSize} - ${upToSize} ${this.recipe.servings.unit.other}`;
        } else {
          return `${portionSize} ${this.recipe.servings.unit.other}`;
        }
      } else if (
        this.recipe.servings.unit?.one !== null &&
        portionSize === 1
      ) {
        return `${portionSize} ${this.recipe.servings.unit.one}`;
      } else {
        return `${portionSize} ${this.recipe.servings.unit.other}`;
      }
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    printRecipe(event: MouseEvent): void {
      event.preventDefault();
      window.print();
    },
    recommendRecipe(event: MouseEvent): void {
      event.preventDefault();
      window.dispatchEvent(
        new CustomEvent("openModal", {
          detail: { modalId: this.modalId },
        })
      );
    },
    displayIngredient(ingredient: any) {
      let groceryName = "";
      const ingredientName = ingredient?.grocery?.name;
      let ingredientQuantity;

      if (ingredient?.quantity) {
        ingredientQuantity = ingredient?.quantity.toString();
      }

      if (ingredientQuantity === 1 && ingredientName.one !== null) {
        groceryName = ingredientName.one;
      } else if (ingredientQuantity > 1 && ingredientName.two !== null) {
        groceryName = ingredientName.two;
      } else {
        groceryName = ingredientName.other;
      }

      let ingredientRounded;

      if (ingredientQuantity) {
        ingredientRounded = ingredientQuantity.includes(".")
          ? Number(ingredientQuantity).toFixed(2)
          : Number(ingredientQuantity);
      }

      return `<span class="obj-ingredient-list__item--name">${
        ingredientQuantity ? ingredientRounded : ""
      } ${ingredient.grocery.unit ? ingredient.grocery.unit?.one : ""}</span>
        <span class="obj-ingredient-list__item--description">${groceryName} ${
        ingredient.grocery.comment
          ? "(" + ingredient.grocery.comment + ")"
          : ""
      }</span>`;
    },
    secureVideoURL(videoURL:any){
      if(videoURL.includes('https')) {
        return videoURL
      }
      
      let cleanURL = videoURL.replace('http', 'https');
      return cleanURL;
    }
  },
});
